import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { RequestCard } from '../components/RequestCard';

interface ExtendedDonationRequest {
  id: string;
  title?: string;
  details: string;
  amount: number;
  donations: any[];
  createdAt: Date;
  collected: number;
  goal: number;
  isSharedPrivate: boolean;
  uniqueDonorsCount: number;
}

export function SharedRequestDetails() {
  const { id } = useParams();
  const [request, setRequest] = useState<any>(null);

  useEffect(() => {
    const fetchRequest = async () => {
      if (!id) return;
      
      try {
        const requestDoc = await getDoc(doc(db, '2dr_requests', id));
        if (requestDoc.exists()) {
          const data = requestDoc.data();
          // Accepter les demandes publiques ET privées
          const formattedDonations = (data.donations || []).map((d: any) => ({
            ...d,
            date: d.date ? new Date(d.date) : new Date(),
            isAnonymous: !!d.isAnonymous
          }));

          setRequest({
            id: requestDoc.id,
            ...data,
            donations: formattedDonations,
            createdAt: data.createdAt?.toDate() || new Date(),
            collected: formattedDonations.reduce((sum: number, d: any) => sum + d.amount, 0) || 0,
            goal: data.amount || 0,
            details: data.details || '',
            isSharedPrivate: !data.isPublic, // Indiquer si c'est une demande privée partagée
            uniqueDonorsCount: formattedDonations.filter((d: any) => !d.isAnonymous).length
          } as ExtendedDonationRequest);
        }
      } catch (error) {
        console.error('Erreur:', error);
      }
    };

    fetchRequest();
  }, [id]);

  if (!request) {
    return <div className="text-center text-gray-400 mt-8">Demande introuvable</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <RequestCard
        {...request}
        showAuthPrompt={true}
        showControls={false}
        showDetails={true}
        description={request?.details}
        collected={request?.collected}
        goal={request?.goal}
        isSharedPrivate={!request?.isPublic} // Passer l'état privé/public
      />

      <div className="mt-8 flex gap-4 justify-center">
        <Link 
          to="/register" 
          className="text-green-500 hover:text-green-400 text-center px-4 py-1 text-sm"
        >
          Créer un compte
        </Link>
        
        <Link 
          to="/login" 
          className="text-gray-400 hover:text-gray-300 text-center px-4 py-1 text-sm"
        >
          Se connecter
        </Link>
      </div>
    </div>
  );
} 